<template>
    <v-dialog v-model="d" width="60%" persistent>
        <v-card>
            <v-card-title>Manage Period</v-card-title>
            <v-card-text>
                <v-text-field label="Name" v-model="active.name" color="primary" />
                <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false" :return-value.sync="active.startDate" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field :value="computedStartDateFormattedMomentjs" label="Start Date" readonly v-on="on" clearable />
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="active.startDate" no-title scrollable>
                        <v-spacer />
                        <v-btn text color="primary" @click="startMenu = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.startMenu.save(active.startDate)">OK</v-btn>
                    </v-date-picker>
                </v-menu>
                <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" :return-value.sync="active.endDate" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field :value="computedEndDateFormattedMomentjs" label="End Date" readonly v-on="on" clearable />
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="active.endDate" no-title scrollable>
                        <v-spacer />
                        <v-btn text color="primary" @click="endMenu = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.endMenu.save(active.endDate)">OK</v-btn>
                    </v-date-picker>
                </v-menu>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="savePeriod">Save Period</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex';
    import {PeriodsHttp} from "../../http/PeriodsHttp";
    import moment from "moment";
    export default {
        name: "PeriodModal",
        data() {
            return {
                isLoading: false,
                startMenu: false,
                endMenu: false
            }
        },
        computed: {
            ...mapState("periods", ["managePeriodDialog", "activePeriod"]),
            d: {
                get() {
                    return this.managePeriodDialog;
                }
            },
            active: {
                get() {
                    return this.activePeriod;
                }
            },
            computedStartDateFormattedMomentjs () {
                return this.active.startDate ? moment(this.active.startDate).format('DD/MM/YYYY') : ''
            },
            computedEndDateFormattedMomentjs () {
                return this.active.endDate ? moment(this.active.endDate).format('DD/MM/YYYY') : ''
            },
        },
        methods: {
            ...mapActions("periods", ["setActivePeriod", "setManagePeriodDialog", "setPeriods"]),
            ...mapMutations("app", ["setToast"]),
            async savePeriod() {
                try {
                    this.isLoading = true;
                    if (!this.active._id) {
                        await PeriodsHttp.createNewPeriod(this.active);
                    } else {
                        await PeriodsHttp.updatePeriod(this.active);
                    }
                    this.setToast({color: 'success', text: 'Period saved successfully', show: true});
                    await this.setPeriods();
                    await this.setActivePeriod({});
                    await this.setManagePeriodDialog(false);
                } catch (err) {
                    this.setToast({color: 'error', text: err.response.data, show: true})
                } finally {
                    this.isLoading = false;
                }
            },
            async closeDialog() {
                await this.setActivePeriod({});
                await this.setManagePeriodDialog(false);
            }
        }
    }
</script>

<style scoped>

</style>
